import React, {useState} from "react"

import VScroll from "../../../scrolling/custom-v-scroll/v-scroll"
import {ProjectIconCategory} from "../../../../gd/const/item-icon/project-categories";
import SearchInput from "../../../../gd-ui/search/search";
import IconItem from "./icon-item";
import {ItemIconDict} from "../../../../gd/const/item-icon/icon/icons";
import {IconSelectorProps} from "../icon-selector";
import {TaskIconCategory} from "../../../../gd/const/item-icon/task-categories";
import {GoalsIconCategory} from "../../../../gd/const/item-icon/goals-categories";

// const debug = "IconTab_Content"
const debug = false

export default function IconTab_Content(props: IconSelectorProps) {

    const [searchQuery, setSearchQuery] = useState<string>('')
    const [searchResult, setSearchResult] = useState(props.iconCategories)
    const [icon, setIcon]   = useState<string|undefined>(props.icon)

    const onIconSelect = (value: string) => {
        setIcon(value)
        props.onChange?.(value)
    }

    const onSearch = (query: string)=> {

        query = query.trim()

        setSearchQuery(query)

        if (query.length === 0) {
            setSearchResult(props.iconCategories)
            return
        }

        const searchResult: ProjectIconCategory[] | TaskIconCategory[] | GoalsIconCategory[] = []

        _.map(props.iconCategories, (category: ProjectIconCategory)=> {

            const filteredIcons: string[] = _.filter(category.itemIcons, (icon: string)=> {
                return !!ItemIconDict[icon].keyword?.toLowerCase().includes(query.toLowerCase())
            })

            if (!_.isEmpty(filteredIcons)) {
                searchResult.push({
                    name        : category.name,
                    itemIcons   : filteredIcons
                })
            }
        })

        setSearchResult(searchResult)
    }

    debug && console.log(debug, 'render', icon)

    return (
        <>
            <div className="p-10">
                <SearchInput size           = {36}
                             placeholder    = "Search..."
                             value          = {searchQuery}
                             onChange       = {onSearch}/>
            </div>

            {_.isEmpty(searchResult) &&
                <div className="flex-row-center-center ui5-txt-not-important h-100">No results found</div>
            }

            <VScroll containerClass="ui5-popover-menu max-h-400">
                {_.map(searchResult, (iconCategory: ProjectIconCategory, categoryKey: number) =>
                    <div key={categoryKey}>
                        <div className="ui5-txt-not-important-tiny fw-600 p-h-10 m-t-5">{iconCategory.name}</div>
                        <div className="icons-group">
                            {_.map(iconCategory.itemIcons, (value: string, itemKey: number) => {
                                const classes = Classes("block", {
                                    selected: value === icon
                                })

                                return <IconItem key            = {itemKey}
                                                 classes        = {classes}
                                                 value          = {value}
                                                 onIconSelect   = {onIconSelect}/>
                            })}
                        </div>
                    </div>
                )}
            </VScroll>
        </>
    )
}

